import React from "react";

export const SettingsBackHandler = ({ title, locals, customBackUrl }) => {
  return (
    <a
      className="only-show-mobile"
      role="settings-back-handler"
      href={customBackUrl || `/coaching-portal/settings/settings-menu`}
    >
      <img src="/img/new-icons/arrow-left.svg" />
      <h4>{title}</h4>
    </a>
  );
};
